module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"pros":"Pros","cons":"Cons","generateProsCons":"Generate Pros and Cons"}}')
  delete Component.options._Ctor
}
